<div class="img-wrapper">
    <div class="lable-block" *ngIf="product.new"><span class="lable3">new</span></div>
    <div class="front">
        <a [routerLink]="['/shop/product/left/sidebar', product.title.replace(' ', '-'), product.sku]">
            <img  [defaultImage]="'assets/images/product/placeholder.jpg'"
                  [lazyLoad]="product.images[0]" class="img-fluid"
                  alt="{{ product.images[0] }}">
        </a>
    </div>
    <div class="cart-box">
        <!-- <button title="Agregar al carrito" (click)="CartModal.openModal(product)" *ngIf="cartModal && product.activaStock === true">
        	<i class="ti-shopping-cart"></i> 
        </button>
        <button title="Agregar al carrito" (click)="addToCart(product)" *ngIf="!cartModal && product.activaStock === true && product.stock > 0">
        	<i class="ti-shopping-cart"></i> 
        </button> -->
        <a href="javascript:void(0)" (click)="addToWishlist(product)" title="Agregar a Lista de Deseos">
        	<i class="ti-heart" aria-hidden="true"></i>
        </a>
        <a href="javascript:void(0)" class="mobile-quick-view" (click)="QuickView.openModal()" title="Vista Rápida">
        	<i class="ti-search" aria-hidden="true"></i>
        </a>
        <a href="javascript:void(0)" (click)="addToCompare(product)" title="Comparar">
        	<i class="ti-reload" aria-hidden="true"></i>
        </a>
    </div>
    <!-- <div class="quick-view-part">
        <a href="javascript:void(0)" (click)="QuickView.openModal()" title="Quick View">
        	<i class="ti-search" aria-hidden="true"></i>
        </a>
    </div> -->
</div>
<div class="product-info">
    <!-- <bar-rating [rate]="5" [readOnly]="true"></bar-rating> -->
    <a [routerLink]="['/shop/product/left/sidebar/', product?.title.replace(' ', '-')]">
    	<h6>{{ product?.title | titlecase }}</h6>
    </a>
    <h4>{{ product?.price * currency?.price | discount:product | currency:currency?.currency:'symbol' }}</h4>
    <div class="delivery-txt pt-2" *ngIf="product.envioGratis===true">Envío Gratis</div>
</div>

<app-quick-view #quickView [product]="product" [currency]="currency"></app-quick-view>
<app-cart-modal #cartModal [product]="product" [currency]="currency" *ngIf="cartModal"></app-cart-modal>